import React, {Component} from 'react';
import {connect} from 'react-redux';
import {cekCookies} from '../../../../actions';
import { CONFIG } from '../../../../config';
import accountManagement from '../../../../apis/accountManagement';
import __ from 'lodash';
import Loader from '../../../Loader';
import LoaderModal from '../../../modal/LoaderModal';
import {Link} from 'react-router-dom';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

class ExamList extends Component {
    constructor(props) {
      super(props);
      this.state = {
        error: null,
        listProfil: [],
        listSubProfil:[],
        resMessage: {},
        isFetching: false,
        isSearch: false,
        profil: {},
        subProfil: {},
        openDialog: false,
      }
      this.handler = this.handler.bind(this);
      this.addMapel = this.addMapel.bind(this);
      this.editMapel = this.editMapel.bind(this);
    }

    handler(id) {
        this.props.onEdit(id);
    }  
    
    addMapel(idProfil, idKelas) {
        this.props.addMapel(idProfil, idKelas);
    } 

    editMapel(idProfilCbt, idSubProfilCbt, idKelas) {
        this.props.editMapel(idProfilCbt, idSubProfilCbt, idKelas);
    }

    async componentDidMount() {
        document.title = "List Exam";
        this.setState({isFetching:true}) 
        await this.props.cekCookies();       
        if(!__.isEmpty(this.props.account)) {
            this.fetchExam();
        }   
        this.setState({isFetching:false})     
    }

    fetchExam = async() => {   
        this.setState({isSearch:true})     
        const resExam = await accountManagement.get(CONFIG.EXAM_LIST + '/' + this.props.account.idSekolah)
            .catch(function(error){
                this.setState({ error });
            })
        if(resExam){
            if(resExam.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    listProfil: resExam.data.data.profil,
                    listSubProfil: resExam.data.data.subProfil,
                })
            }
            
        }
        this.setState({isSearch:false})
    }

    delete = async(id) => {        
        this.setState({ isFetching: true })
        const { listProfil } = this.state;
        await this.props.cekCookies(); 
        const json = { 'id' : id}
        const resDelete = await accountManagement.post(CONFIG.EXAM_DELETE, json)
            .catch(function(error){
                this.setState({error});
            });
        
        if (resDelete) {
            if(resDelete.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({ 
                    openDialog: false,
                    resMessage: resDelete.data.errorSchema,
                    listProfil: listProfil.filter(profil => profil.idProfilCbt !== id)
                });
            }
        }      
        this.setState({isFetching: false })
    }

    deleteSub = async(id) => {        
        this.setState({ isFetching: true })
        const { listSubProfil } = this.state;
        await this.props.cekCookies(); 
        const json = { 'id' : id}
        const resDelete = await accountManagement.post(CONFIG.EXAM_DELETE_MAPEL, json)
            .catch(function(error){
                this.setState({error});
            });
        
        if (resDelete) {
            if(resDelete.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({ 
                    openDialog: false,
                    resMessage: resDelete.data.errorSchema,
                    listSubProfil: listSubProfil.filter(sub => sub.idSubProfilCbt !== id)
                });
            }
        }      
        this.setState({isFetching: false })
    }

    loading = () =>{
        if(this.state.isSearch){
            return(
                <Loader />
            )
        }
    }

    showDialog = (dataProfil, dataSubProfil) => {        
        this.setState({openDialog: true})
        if(dataSubProfil === null) {
            this.setState({
                profil: dataProfil,
                subProfil: {}            
            })
        } else {
            this.setState({
                subProfil: dataSubProfil,
                profil: {}            
            })
        }
        
    }

    confirmDialog() {
        //onClick={() => this.showDialog(jadwal)}
        const {openDialog, profil, subProfil} = this.state;    
        //console.log(profil, subProfil)  
        let title, content, button;
        if(!__.isEmpty(profil)) {
            title = "Hapus Profil?"
            content = <DialogContentText id="alert-dialog-description">
                        Menghapus Profil juga akan menghapus Jadwal & report Siswa<br/>
                        Yakin akan menghapus Profil <strong>{profil.namaProfil}</strong> ?
                    </DialogContentText>
            button = <button className="btn btn-primary" onClick={() => this.delete(profil.idProfilCbt)} autoFocus> Ya </button>     
        } else {
            title = "Hapus Mata Pelajaran?"
            content = <DialogContentText id="alert-dialog-description">
                        Yakin akan menghapus Mata Pelajaran <strong>{subProfil.nama}</strong> ?
                    </DialogContentText>
            button = <button className="btn btn-success" onClick={() => this.deleteSub(subProfil.idSubProfilCbt)} autoFocus> Ya </button>          
        }
        const handleClose = () => { this.setState({openDialog: false}) };        
        return (
            <>
            <Dialog
                open={openDialog}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
                <DialogContent>
                    {content}
                </DialogContent>
                <DialogActions>
                    <button className="btn btn-danger" onClick={handleClose}> Tidak </button>
                    {button}               
                </DialogActions>
            </Dialog>
            </>
        )
    }

    

    render() {
        const { error, listProfil, listSubProfil} = this.state;
        if(error){
            return (
                <div>Error: {error.message}</div>
              )
        } 
        else {
            return (                  
                <div id="accordion">      
                <LoaderModal isFetching={this.state.isFetching}/>    
                {this.loading()}      
                {listProfil.map((profil, index) =>
                <div className="card" style={{marginBottom: '5px'}} key={profil.idProfilCbt}>
                    <div className="card-header">                    
                        <div className="row">
                            <div className="col-sm-5 col-xs-5">
                                <div className="row">
                                    <div className="col-sm-9 col-xs-9">
                                        <a className="card-link" data-toggle="collapse" href={'#col-parent-' + profil.idProfilCbt}>
                                        {index + 1}. {profil.namaProfil} <i className="fa fa-angle-down" aria-hidden="true"></i>
                                        </a>
                                    </div>
                                    <div className="col-sm-3 col-xs-3">
                                        <button onClick={() => this.addMapel(profil.idProfilCbt,profil.idKelas)} className="btn btn-sm btn-outline-primary" title="tambah mapel"><i className="fa fa-plus"> Mapel</i></button>
                                    </div>    
                                </div>
                            </div>

                            <div className="col-sm-4 col-xs-4">
                                {profil.namaKelas}
                            </div>

                            <div className="col-sm-1 col-xs-1">
                                {profil.kodeSubTipeCbt}
                            </div>

                            <div className="col-sm-2 col-xs-2">
                                <div className="button-group pull-right">                                        
                                    <button className="btn btn-outline-warning btn-sm" title="Edit" onClick={() => this.handler(profil.idProfilCbt)}>
                                        <i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>&nbsp;
                                    <button onClick={() => this.showDialog(profil, null)} 
                                        className="btn btn-outline-danger btn-sm" title="Hapus"><i className="fa fa-times" aria-hidden="true"></i></button>										
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div  id={'col-parent-' + profil.idProfilCbt} className="collapse" data-parent="#accordion">
                    {listSubProfil.map((sub, i) => (
                        
                        profil.idProfilCbt == sub.idProfilCbt ?                        
                            <div className="card-body" key={sub.idSubProfilCbt}>
                                <div className="row">
                                    <div className="col-sm-3 col-xs-3"><i className="fa fa-hashtag" aria-hidden="true"></i> {sub.nama}</div>
                                    
                                    <div className="col-sm-2 col-xs-2">Soal : {sub.jumlahSoal}                                     
                                        <Link to={{ pathname: '/examsoal/'+ sub.idSubProfilCbt + '/exam' }} >
                                            <button className="btn btn-sm btn-outline-dark pull-right" title="tambah soal"><i className="fa fa-plus"> Soal </i></button>
                                        </Link>
                                    </div>
                                    <div className="col-sm-2 col-xs-2">Durasi : {sub.durasi}<small>m</small></div>
                                    <div className="col-sm-2 col-xs-2">Random : {sub.random == '1' ? 'ON' : 'OFF'}</div>    
                                    <div className="col-sm-1 col-xs-1">KKM : {sub.kkm}</div>                                
                                    <div className="col-sm-2 col-xs-2">
                                        <div className="button-group pull-right">
                                            <button className="btn btn-outline-warning btn-sm" onClick={() => this.editMapel(profil.idProfilCbt, sub.idSubProfilCbt, profil.idKelas)}>Edit</button>&nbsp;
                                            <button className="btn btn-outline-danger btn-sm" 
                                            onClick={() => this.showDialog(null, sub)}>Hapus</button>								
                                        </div>
                                    </div>
                                </div>
                            </div>                         
                            : 
                            <div></div>    
                        ))}
                    </div>
                </div>                   
                )}
                {this.confirmDialog()}
                </div> 
            )
        }
    }
    

}

const mapStateToProps = (state) => {
    return{
        account: state.account        
    };
}

export default connect(mapStateToProps, {cekCookies})(ExamList);